import {
    NinchatCheckIconSolid, XIcon,
} from 'components/Icon'

import {
    styledDescription,
    styledHorizontal,
    styledInput,
    styledSwitch,
    styledSwitchInnerWrapper,
} from './styles/SwitchView'
import React from 'react'
import {SwitchProps} from './types'

import {styled} from '../../stitches/config'
import {styledLabel} from '../Form/styles/FormView'
import {useTranslation} from 'react-i18next'

const StyledSwitch = styled('div', styledSwitch)
const StyledHorizontal = styled('div', styledHorizontal)
const StyledLabel = styled('label', styledLabel)
const StyledLabelHorizontal = styled('label', styledLabel, {marginTop: 0})
const StyledDescription = styled('label', styledDescription)
const StyledInput = styled('input', styledInput)
const StyledSwitchInnerWrapper = styled('div', styledSwitchInnerWrapper)

const SwitchView = React.forwardRef<HTMLInputElement, SwitchProps>((props, _ref): React.ReactElement => {
    const {
        id,
        label,
        onChange,
    } = props

    const {
        description,
        horizontal,
        on,
        disabled,
        hideStateLabel,
        ...inputProps
    } = props

    const {t} = useTranslation()

    const labelId = `label-${id}`
    const descriptionId = `description-${id}`

    const labelBy = `${labelId} ${descriptionId}`

    const [isOn, setIsOn] = React.useState(on)

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIsOn(e.target.checked)
        onChange?.(e)
    }

    React.useEffect(() => {
        // TODO: Invent better way to check Switch status eg. via ref
        /*
        "on" prop defines if Switch is on or off by default. It is updated in effect since in some cases it is
        asynchronously updated. When using react-hook-form, on prop is set eg. like this:
        on={getValues('queueSettings.audience_registration')}
        */
        if (typeof on !== 'undefined') {
            setIsOn(on)
        }
    }, [on])


    return (
        <StyledSwitch data-id='switch' disabled={disabled}>
            {!horizontal &&
                <>
                    <StyledLabel htmlFor={id} id={labelId}>{label}</StyledLabel>
                    <StyledDescription htmlFor={id} id={descriptionId}>{description}</StyledDescription>
                </>}
            <StyledHorizontal>
                <StyledSwitchInnerWrapper isOn={isOn}>
                    <StyledInput
                        {...inputProps}
                        aria-checked={isOn}
                        aria-labelledby={labelBy}
                        checked={isOn}
                        disabled={disabled}
                        onChange={handleChange}
                        ref={_ref}
                        role='switch'
                        type='checkbox'
                    />
                    {isOn ? <NinchatCheckIconSolid aria-hidden='true' /> : <XIcon aria-hidden='true' />}
                </StyledSwitchInnerWrapper>
                {!hideStateLabel && <StyledLabelHorizontal htmlFor={id} id={labelId}>{label && horizontal ? label : isOn ? t('On') : t('Off')}</StyledLabelHorizontal>}
                {Boolean(horizontal) &&
                    <StyledDescription htmlFor={id} id={descriptionId} style={{visibility: 'hidden'}}>{description}</StyledDescription>}
            </StyledHorizontal>
        </StyledSwitch>
    )
})

SwitchView.displayName = 'SwitchView'

SwitchView.defaultProps = {
    description: undefined,
    horizontal: false,
    label: undefined,
}

export default SwitchView
